import Axios from "../config/Axios";
// import axios from 'axios'
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    ONBOARD_FIRST_STEP_REQUEST,
    ONBOARD_FIRST_STEP_SUCCESS,
    ONBOARD_FIRST_STEP_FAIL,
    ONBOARD_SECOND_STEP_REQUEST,
    ONBOARD_SECOND_STEP_SUCCESS,
    ONBOARD_SECOND_STEP_FAIL,
    ONBOARD_THIRD_STEP_REQUEST,
    ONBOARD_THIRD_STEP_SUCCESS,
    ONBOARD_THIRD_STEP_FAIL,
    ONBOARD_FINAL_REQUEST,
    ONBOARD_FINAL_SUCCESS,
    ONBOARD_FINAL_FAIL,
    USER_PROFILE_REQUEST,
    USER_PROFILE_SUCCESS,
    USER_PROFILE_FAIL,
    USER_TOUR_SHOW,
    PAYMENT_CHECKOUT_REQUEST,
    PAYMENT_CHECKOUT_SUCCESS,
    PAYMENT_CHECKOUT_FAIL,
    PAYMENT_VALIDATE_REQUEST,
    PAYMENT_VALIDATE_SUCCESS,
    PAYMENT_VALIDATE_FAIL,
} from '../constants/userConstants';

import {
    GENERATE_LINKEDINAD_RESET,
    GENERATE_TAGLINE_RESET,
    GENERATE_AMAZONDESC_RESET,
    GENERATE_GOOGLEAD_RESET,
    GENERATE_BLOGIDEAS_RESET,
    GENERATE_BLOGINTRO_RESET,
    GENERATE_BLOGQUOTE_RESET
} from '../constants/generateConstants';

const login = (email, password) => async (dispatch) => {
    try {
        dispatch({
            type: USER_LOGIN_REQUEST,
        })

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }

        const { data } = await Axios.post("/auth/login", { email, password }, config);

        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: data
        })

        localStorage.setItem('userInfo', JSON.stringify(data))
    } catch (error) {
        dispatch({
            type: USER_LOGIN_FAIL,
            payload: error.message,
        })
    }
}

const logout = () => (dispatch) => {
    localStorage.removeItem('userInfo');
    // localStorage.removeItem('linkedinAd');
    // localStorage.removeItem('tagline');
    // localStorage.removeItem('googleAd');
    // localStorage.removeItem('amazondesc');
    dispatch({ type: USER_LOGOUT });
    // dispatch({ type: GENERATE_LINKEDINAD_RESET });
    // dispatch({ type: GENERATE_TAGLINE_RESET });
    // dispatch({ type: GENERATE_AMAZONDESC_RESET });
    // dispatch({ type: GENERATE_GOOGLEAD_RESET });
}

const register = (email, password, name) => async (dispatch) => {
    try {
        dispatch({
            type: USER_REGISTER_REQUEST,
        })

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }

        const { data } = await Axios.post("/auth/signup", { email, password, name }, config);


        dispatch({
            type: USER_REGISTER_SUCCESS,
            payload: data
        })

        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: data
        })

        localStorage.setItem('userInfo', JSON.stringify(data))
    } catch (error) {
        dispatch({
            type: USER_REGISTER_FAIL,
            payload: error.message,
        })
    }
}

const getUserProfile = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: USER_PROFILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.get("/user/profile", config);


        dispatch({
            type: USER_PROFILE_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: USER_PROFILE_FAIL,
            payload: error.message,
        })
    }
}

const firstStepOnboard = (item) => async (dispatch) => {
    try {
        dispatch({
            type: ONBOARD_FIRST_STEP_REQUEST,
        })

        dispatch({
            type: ONBOARD_FIRST_STEP_SUCCESS,
            payload: item
        })

    } catch (error) {
        dispatch({
            type: ONBOARD_FIRST_STEP_FAIL,
            payload: error.message,
        })
    }
}

const secondStepOnboard = (item) => async (dispatch) => {
    try {
        dispatch({
            type: ONBOARD_SECOND_STEP_REQUEST,
        })

        dispatch({
            type: ONBOARD_SECOND_STEP_SUCCESS,
            payload: item
        })

    } catch (error) {
        dispatch({
            type: ONBOARD_SECOND_STEP_FAIL,
            payload: error.message,
        })
    }
}

const thirdStepOnboard = (item) => async (dispatch) => {
    try {
        dispatch({
            type: ONBOARD_THIRD_STEP_REQUEST,
        })

        dispatch({
            type: ONBOARD_THIRD_STEP_SUCCESS,
            payload: item
        })

    } catch (error) {
        dispatch({
            type: ONBOARD_THIRD_STEP_FAIL,
            payload: error.message,
        })
    }
}

const finalStepOnboard = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: ONBOARD_FINAL_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();
        const { onboardFirstStep: { firstStepData } } = getState();
        const { onboardSecondStep: { secondStepData } } = getState();
        const { onboardThirdStep: { thirdStepData } } = getState();

        const allStepsData = {
            industry: firstStepData.industry,
            organization: firstStepData.companyName,
            isSelfEmployed: firstStepData.isSelfEmployed,
            country: firstStepData.country,
            organizationSize: firstStepData.organizationSize.value,
            usingFor: secondStepData.usingFor.value,
            mainPurpose: thirdStepData.mainPurpose,
        }

        const { data } = await Axios.post("/user/onboarding", allStepsData, {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        })

        dispatch({
            type: ONBOARD_FINAL_SUCCESS,
            payload: data
        })

        dispatch({
            type: USER_TOUR_SHOW,
            payload: true
        })

    } catch (error) {
        dispatch({
            type: ONBOARD_FINAL_FAIL,
            payload: error.message,
        })
    }
}

const checkoutPayment = (planId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PAYMENT_CHECKOUT_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/user/payment/checkout", { planId }, config);


        dispatch({
            type: PAYMENT_CHECKOUT_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: PAYMENT_CHECKOUT_FAIL,
            payload: error.message,
        })
    }
}

const validatePayment = (sessionId, orderId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PAYMENT_VALIDATE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/user/payment/validate", { sessionId, orderId }, config);


        dispatch({
            type: PAYMENT_VALIDATE_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: PAYMENT_VALIDATE_FAIL,
            payload: error.message,
        })
    }
}

export {
    login,
    register,
    getUserProfile,
    logout,
    firstStepOnboard,
    secondStepOnboard,
    thirdStepOnboard,
    finalStepOnboard,
    checkoutPayment,
    validatePayment
}
